import { Component, OnInit, AfterContentInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { AppGlobals } from './app.globals';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
  RedirectRequest,
  SilentRequest,
} from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { msalConfig, loginRequest } from './auth-config';
import { AppConfig } from './app.config';
import { Location } from '@angular/common';
import { DxMenuTypes } from 'devextreme-angular/ui/menu';
import { locale, loadMessages } from 'devextreme/localization';
import deMessages from 'devextreme/localization/messages/de.json';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { ItemClickEvent } from 'devextreme/ui/menu';
import { DxDrawerComponent } from 'devextreme-angular';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import config from 'devextreme/core/config';
import { FeatureFlags } from './interfaces/enums/feature-flag';
import { LogoService } from './services/logo.service';
import { ReleaseNoticeService } from './services/release-notice.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit, AfterContentInit {
  loginDisplay = false;

  isLoggedIn: boolean = false;

  sideNavOpen: boolean = false;

  isLoggedOut: boolean = true;

  popupVisible: boolean = false;

  logPopUpVisible: boolean = false;

  logRequest: any = {};

  text: string;

  selectedOpenMode = 'overlap';

  selectedPosition = 'left';

  selectedRevealMode = 'slide';

  isDrawerOpen = false;

  elementAttr: any;

  // titleText: string = "";

  appVersion = AppConfig.APPVersion;

  breadCrumbs: any = AppGlobals.breadCrumbs;

  selectedMenuItem: any = {};
  selectedMenuIconItem: any = {};
  SideNavIndex: number = 0;

  sideNavHeadings: any = [];
  sideNavHeadingsIcons: any = [];
  sideNavHeadingLogout: any = [];
  sideNavHeadingLogoutIcons: any = [];

  selectedItem: any = localStorage.getItem('selectedMenuItemId');
  selectedItemIcon: any = localStorage.getItem('selectedMenuItemIconId');

  selectedItemId: any = 1;
  selectedItemIconId: any = 1;

  itemTopIndex: any = this.selectedItemId;
  itemTopIconIndex: any = this.selectedItemIconId;

  itemBottomIndex: any = '';
  itemBottomIconIndex: any = '';

  showSubmenuModes = [
    {
      name: 'onHover' as DxMenuTypes.SubmenuShowMode,
      delay: { show: 0, hide: 500 },
    },
    {
      name: 'onClick' as DxMenuTypes.SubmenuShowMode,
      delay: { show: 0, hide: 300 },
    },
  ];

  showFirstSubmenuModes: any = this.showSubmenuModes[0];

  @ViewChild('topMenu') topMenu;
  @ViewChild('mainmenu') mainMenu: DxDrawerComponent;

  sideNavHeadingVersion: any = [{ id: 10, name: this.appVersion }];

  toastmessage: any = '';
  toastType: any = '';
  toastVisible: any = '';

  routeText: any = '';

  menuId: any = null;

  authErrorMessage = $localize`There was a problem with signing into your account. Your details might not yet be registered on the system. Please contact your system administrator.`;

  private readonly _destroying$ = new Subject<void>();

  constructor(
    private apiService: AuthService,
    private featureFlagService: FeatureFlagService,
    private router: Router,
    private appGlobals: AppGlobals,
    private broadcastService: MsalBroadcastService,
    private authService: MsalService,
    private location: Location,
    private titleService: Title,
    private logoService: LogoService,
    private releaseNoticeService: ReleaseNoticeService
  ) {
    loadMessages(deMessages);
    locale('de-DE');
    config({
      defaultCurrency: 'EUR',
    });
    this.toastmessage = AppGlobals.toastmessage;
    this.toastType = AppGlobals.toastType;
    this.toastVisible = AppGlobals.toastVisible;

    this.routeText = this.location.path();
  }

  async getUserDetails(): Promise<void> {
    if (!await this.setTenantId()) return;

    try {
      const result: any = await this.apiService.getUserDetails({});
      if (result.hasError === true) {
        AppGlobals.ShowErrorMessage(result.feedback);
        return;
      }
      if (result.isValidationError === false) {
        if (result.isAuthenticationError) {
          this.isLoggedIn = false;
          this.isLoggedOut = true;
          this.sideNavOpen = false;
          return;
        } else {
          this.appGlobals.SetUserDetails(result.userName, result.userRole, result.userEmail);

          AppGlobals.SetUserPermissions(result.userPermissions);

          this.isLoggedIn = true;
          AppGlobals.LoggedIn = true;
          this.isLoggedOut = false;

          this.releaseNoticeService.checkForNewRelease();
        }
      }
    } catch (error: any) {
      AppGlobals.ShowErrorMessage(this.authErrorMessage);

      if (error.status === 401) {
        this.isLoggedIn = false;
        AppGlobals.LoggedIn = false;
        return;
      }
      //AppGlobals.ShowErrorMessage(error);
    }
  }

  private loginHandled: boolean = false;

  private registerBroadcastEvents() {
    this.broadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });

    this.broadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            (msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
            !this.loginHandled
        ),
        takeUntil(this._destroying$)
      )
      .subscribe((result: EventMessage) => {
        this.loginHandled = true;
        const payload = result.payload as AuthenticationResult;

        this.authService.instance.setActiveAccount(payload.account);

        this.apiService.$accessToken.next(payload.accessToken);

        const account = this.authService.instance.getActiveAccount();
        if (!account) return;

        // ;
        if (account.tenantId != '9188040d-6c67-4c5b-b112-36a304b66dad') {
          // ✅ Acquire token specifically for Microsoft Graph
          this.authService.instance
            .acquireTokenSilent({
              account,
              scopes: ['https://graph.microsoft.com/User.Read.All'],
            })
            .then((graphResult: AuthenticationResult) => {
              const graphToken = graphResult.accessToken;
              this.apiService.$graphToken.next(graphToken);

              // ✅ Now use this Graph token
              fetch('https://graph.microsoft.com/v1.0/me', {
                headers: {
                  Authorization: `Bearer ${graphToken}`,
                },
              }).then(graphResponse => {
                if (!graphResponse.ok) {
                  if (graphResponse.status === 403 || graphResponse.status === 401) {
                    this.handlePermissionError();
                  } else {
                    console.error('Unexpected Graph error', graphResponse.statusText);
                  }
                } else {
                  this.setLoginDisplay();

                  const returnUrl = sessionStorage.getItem('returnUrl');
                  if (returnUrl) {
                    sessionStorage.removeItem('returnUrl');
                    this.router.navigateByUrl(returnUrl);
                  }
                }
              });
            })
            .catch(error => {
              if (error.errorCode === 'interaction_required') {
                // ❌ Graph consent missing → redirect to consent
                this.authService.instance.acquireTokenRedirect({
                  scopes: ['https://graph.microsoft.com/User.Read.All'],
                });
              } else {
                console.error('Error acquiring Graph token', error);
              }
            });
        } else {
          this.setLoginDisplay();

          const returnUrl = sessionStorage.getItem('returnUrl');
          if (returnUrl) {
            sessionStorage.removeItem('returnUrl');
            this.router.navigateByUrl(returnUrl);
          }
        }
      });

    this.broadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.SSO_SILENT_SUCCESS
        )
      )
      .subscribe((result: EventMessage) => {
        const payload = result.payload as AuthenticationResult;
        this.authService.instance.setActiveAccount(payload.account);

        this.setLoginDisplay();
      });
  }

  private handlePermissionError() {
    const clientId = AppConfig.ClientId;
    const redirectUri = AppConfig.SiteBase;
    window.location.href = `https://login.microsoftonline.com/common/adminconsent?client_id=${clientId}&redirect_uri=${redirectUri}`;
  }

  async setTenantId(): Promise<boolean> {
    try {
      const result = await this.apiService.getProjectUser({});
      if (result.hasError === true) {
        AppGlobals.ShowErrorMessage(result.feedback);
        return false;
      }

      AppGlobals.TenantId = result.tenantId;

      var featureFlags = result.tenants[0].featureFlags as FeatureFlags[];
      if (featureFlags) {
        this.appGlobals.SetFeatures(featureFlags);
      }

      var primaryColor = result.tenants[0].primaryColor;
      var secondaryColor = result.tenants[0].secondaryColor;
      var title = result.tenants[0].name;
      var domain = result.tenants[0].domain;
      var uiDomain = result.tenants[0].uiDomain;

      document.documentElement.style.setProperty('--color-primary', primaryColor);
      document.documentElement.style.setProperty('--color-secondary', secondaryColor);

      if (title) {
        AppGlobals.EnvironmentName = title;
        this.titleService.setTitle(title);
      }
    } catch (error: any) {
      AppGlobals.ShowErrorMessage(error.error?.feedback || error.message || this.authErrorMessage);
      return false;
    }
    await this.loadBrandingLogos();
    return true;
  }

  private async loadBrandingLogos(): Promise<void> {
    try {
      const response = await this.logoService.GetLogos();
      if (!response || response.hasError) {
        return;
      }

      if (response.logos) {
        this.logoService.eventEmitter.next({
          smallLogo: response.logos.smallLogo as any,
          largeLogo: response.logos.largeLogo as any,
          favicon: response.logos.favicon as any
        });
      }
    } catch {
      // Branding logos are non-critical; ignore failures here
    }
  }

  ngOnInit(): void {
    AppGlobals.setBreadCrumbsFromLocalStorage();
    this.registerBroadcastEvents();

    var emptyArrray = [];
    if (this.breadCrumbs === emptyArrray) {
      let bc = localStorage.getItem('breadCrumbs');
      let BC = JSON.parse(bc);
      this.breadCrumbs = BC;
      AppGlobals.breadCrumbs = BC;
    }

    // const accounts = this.authService.instance.getAllAccounts();
    // if (accounts.length > 0) {
    //   ;
    //   this.authService.instance.setActiveAccount(accounts[0]); // You can choose a specific account if needed
    // }

    // setTimeout(() => {
    //   this.titleText = AppGlobals.TopNavTitle;
    // }, 5000);
  }

  login() {
    // location.path(), not router.url: the adminGuard on /config parks the initial
    // navigation until permissions load, so with Angular's default deferred url update
    // router.url is still '/' here and the deep link would be lost across the redirect.
    // Location strips the locale base href ('/en/'), which raw location.pathname would not.
    sessionStorage.setItem('returnUrl', this.location.path() || '/');
    //return;
    let rr: RedirectRequest = {
      scopes: loginRequest.scopes,
    };
    this.authService.loginRedirect(rr);
  }

  logout() {
    AppGlobals.ClearClientSession();

    this.authService.logoutRedirect({
      postLogoutRedirectUri: AppConfig.SiteBase,
    });
    AppGlobals.TenantId = '';
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;

    if (this.loginDisplay) {
      this.getTokenSilent();
      if (this.loginDisplay === true) {
        this.getUserDetails();
      }
      return;
    }
  }

  getTokenSilent() {
    let account = this.authService.instance.getAllAccounts()[0];
    const accessTokenRequest: SilentRequest = {
      scopes: loginRequest.scopes,
      authority: msalConfig.auth.authority,
      redirectUri: msalConfig.auth.redirectUri,
      account: account,
    };
    this.authService
      .acquireTokenSilent(accessTokenRequest)
      .toPromise()
      .then(res => { })
      .catch(e => {
        // console.log("acquireTokenPopup catch");
        // console.log(e);
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
  ngAfterContentInit(): void {
    this.isLoggedIn = AppGlobals.LoggedIn;
  }

  userIsLoggedIn(): boolean {
    return AppGlobals.LoggedIn;
  }

  getUserName(): string {
    return AppGlobals.LoggedInUserData.userName;
  }

  toggleDrawer(): void {
    this.isDrawerOpen = !this.isDrawerOpen;
  }

  closeDrawerOnOutsideClick(): any {
    if (this.isDrawerOpen === true) {
      /*       this.opacityTransition = "opacity-transition";
            this.opacityFade = 'opacity-fadeOut'; */
      return true;
    } else {
      /*       this.opacityTransition = "opacity-transition-back";
            this.opacityFade = 'opacity-fadeIn'; */
      return false;
    }
  }

  goTo(path: string): void {
    this.router.navigate([path]);
    if (this.isDrawerOpen === true) {
      this.toggleDrawer();
    }
  }

  onMenuItemClick(e: ItemClickEvent): void {
    console.log(e);

    // e.itemData.onClick();
  }
}
